import React from 'react'

export default (props) => (
  <span className="inline-block bg-gray-200 rounded-sm px-3 py-2 font-semibold text-gray-700 cursor-default mb-2 mr-2" {...props} />
)
